import { DoneActorEvent } from 'xstate';
import {
  RefreshTokenSuccessEvent,
  AuthMachineContext,
  AuthMachineEvents,
} from '../types';

export function setAccessToken({
  context,
  event,
}: {
  context: AuthMachineContext;
  event: AuthMachineEvents;
}) {
  if (!event.type.includes('xstate.done.actor')) return context;

  const e = event as DoneActorEvent<RefreshTokenSuccessEvent>;
  if (e.output.type !== 'REFRESH_TOKEN_SUCCESS') return context;

  return {
    accessToken: e.output.accessToken,
    ignoreRefreshToken: false,
  };
}

export default setAccessToken;
